import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, HStack, Text, useTheme } from "native-base";
import { formatBytes } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import Button from "../atoms/Button";
import Icon from "../icons/Icon";
import DocumentListCard from "../molecules/DocumentListCard";
import useResponsive from "../util/useResponsive";
import Div from "../atoms/Div";
const DocumentUploadFormInner = ({ files, dropzoneProps, inputProps, isDragActive, isUploading, onSelectPress, onDeletePress, onChangeNote, onChangeService, }) => {
    const { colors } = useTheme();
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    const content = {
        desktop: {
            title: t("dropFilesHere"),
            desc: t("orClickButtonToUpload"),
        },
        mobile: {
            title: t("uploadDocuments"),
            desc: t("attachGeneralDocument"),
        },
    };
    const handleDeletePress = (index) => () => {
        onDeletePress(index);
    };
    const handleNoteChange = (index) => (note) => {
        onChangeNote(index, note);
    };
    const handleServiceChange = (index) => (service) => {
        onChangeService(index, service);
    };
    return (_jsx(_Fragment, { children: files.length === 0 ? (_jsx(Div, Object.assign({}, dropzoneProps, { children: _jsxs(Box, Object.assign({ borderStyle: "dashed", borderColor: isDragActive ? "green.500" : "gray.300", flex: 1, justifyContent: "center", alignItems: "center", minHeight: "300px", bgColor: isDragActive ? "green.25" : "transparent", pt: 6, pb: 6, borderWidth: isSmallScreen ? 0 : 2 }, { children: [inputProps && _jsx("input", Object.assign({ type: "hidden" }, inputProps)), _jsx(Icon, { name: "documentBlank", size: 24, fill: colors.green[500] }), _jsx(Text, Object.assign({ mt: 4 }, { children: content[isSmallScreen ? "mobile" : "desktop"]
                            .title })), _jsx(Text, Object.assign({ mb: 4, color: "gray.400" }, { children: content[isSmallScreen ? "mobile" : "desktop"].desc })), _jsx(Button, Object.assign({ onPress: onSelectPress }, { children: t("selectFiles") }))] })) }))) : (_jsxs(_Fragment, { children: [files.map(({ name, size, note }, index) => (_jsx(DocumentListCard, { label: name, subText: formatBytes(size), note: note, onChangeNote: handleNoteChange(index), rightIconName: "trashCan", isEditable: true, loading: isUploading, onRightIconPress: handleDeletePress(index), onChangeService: handleServiceChange(index) }, index))), _jsx(HStack, Object.assign({ justifyContent: "flex-start", pt: 4 }, { children: _jsx(Button, Object.assign({ onPress: onSelectPress, variant: "outlined", leftIconName: "documentAttachment" }, { children: t("attachOtherFiles") })) }))] })) }));
};
export default DocumentUploadFormInner;
